import { isLocalEnv } from '@config/environment'
import { sentryConfig } from '@config/sentry'
import { init, wrapCreateBrowserRouterV7 } from '@sentry/react'
import { createBrowserRouter } from 'react-router'

export const createMonitoredRouter = (...args: Parameters<typeof createBrowserRouter>) => {
  if (isLocalEnv()) {
    // In local env, we don't want to use Sentry
    return createBrowserRouter(...args)
  }

  init(sentryConfig)

  return wrapCreateBrowserRouterV7(createBrowserRouter)(...args)
}
